import { useEffect, useRef, useState } from "react";

const useBackgroundMusic = (src: string) => {
  const audioRef = useRef<HTMLAudioElement>(new Audio(src));
  const [isPlayed, setIsPlayed] = useState(false);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    const audio = audioRef.current;
    audio.loop = true;
    audio.muted = isMuted;

    const handleInteraction = async () => {
      if (!isPlayed) {
        try {
          await audio.play();
          setIsPlayed(true);
          setIsMuted(false);
        } catch (e) {
          console.warn("Auto play failed", e);
        }
      }
    };

    window.addEventListener("click", handleInteraction);
    window.addEventListener("scroll", handleInteraction);

    return () => {
      window.removeEventListener("click", handleInteraction);
      window.removeEventListener("scroll", handleInteraction);
    };
  }, [isPlayed]);

  const toggleMute = () => {
    const audio = audioRef.current;

    if (audio) {
      const newMuteState = !audio.muted;
      audio.muted = newMuteState;
      setIsMuted(newMuteState);

      console.log(newMuteState);

      // 만약 언뮤트 시 아직 재생되지 않았으면 시도
      if (!newMuteState && !isPlayed) {
        audio
          .play()
          .then(() => setIsPlayed(true))
          .catch(console.warn);
      }
    }
  };

  return { isMuted, toggleMute };
};

export default useBackgroundMusic;
